export function buildAdditionalRespiratoryMetricsFields(t) {
  // `fmt` returns just the number so the view can render the `unit` in muted
  // text (matching the main summary rows); "--" carries no unit.
  const formatNumber = (value, decimals = 2) =>
    Number.isFinite(Number(value)) ? Number(value).toFixed(decimals) : "--";
  const bpm = t("result.spiro.rrUnit", "bpm");

  return [
    {
      label: "Inhale/Exhale Ratio",
      i18nKey: "result.spiro.meanExhaleInhaleAreaRatio",
      path: "meanExhaleInhaleAreaRatio",
      fmt: (value) => formatNumber(value, 3),
      unit: null,
    },
    {
      label: "Minimum RR",
      i18nKey: "result.spiro.rrMin",
      path: "rr_min",
      fmt: (value) => formatNumber(value),
      unit: bpm,
    },
    {
      label: "Maximum RR",
      i18nKey: "result.spiro.rrMax",
      path: "rr_max",
      fmt: (value) => formatNumber(value),
      unit: bpm,
    },
    {
      label: "Mean RR",
      i18nKey: "result.spiro.rrMean",
      path: "rr_mean",
      fmt: (value) => formatNumber(value),
      unit: bpm,
    },
    {
      label: "Median RR",
      i18nKey: "result.spiro.rrMedian",
      path: "rr_median",
      fmt: (value) => formatNumber(value),
      unit: bpm,
    },
    {
      label: "Minimum breath duration",
      i18nKey: "result.spiro.minBreathDuration",
      path: "min_breath_duration_seconds",
      fmt: (value) => formatNumber(value),
      unit: "s",
    },
    {
      label: "Maximum breath duration",
      i18nKey: "result.spiro.maxBreathDuration",
      path: "max_breath_duration_seconds",
      fmt: (value) => formatNumber(value),
      unit: "s",
    },
    {
      label: "Mean breath duration",
      i18nKey: "result.spiro.meanBreathDuration",
      path: "mean_breath_duration_seconds",
      fmt: (value) => formatNumber(value),
      unit: "s",
    },
    {
      label: "Breath count",
      i18nKey: "result.spiro.breathCount",
      path: "breath_count",
      fmt: (value) => formatNumber(value, 0),
      unit: null,
    },
    // Quality metrics live in each view's Recording Quality section, so they
    // are intentionally excluded from the shared additional-metrics list.
  ];
}
